import { lazy, Suspense } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import LazyLoading from '../../components/LazyLoading';

const LazyGiftPotOccasion = lazy(
  () => import(/* webpackChunkName: 'GiftPotOccasion' */ './Occasion'),
);

export default function GiftPotOccasion({
  match,
}: RouteComponentProps<{ occasion: string }>) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyGiftPotOccasion occasion={match.params.occasion} />
    </Suspense>
  );
}
